<template>
  <div class="radio-large" :class="{ 'selected' : localValue === vsValue }">
    <vs-radio
        class="items-start"
        v-model="localValue"
        :vs-name="vsName"
        :name="name"
        :data-vv-as="dataVvAs"
        :vs-value="vsValue"
        :v-validate="vValidate"
    >
      <div class="label">{{ label }}</div>
      <div class="slot-content"><slot></slot></div>
    </vs-radio>
  </div>

</template>

<script>

export default {
  name: "radio-large",
  components: {
  },
  props: {
    value: {
      type: String,
    },
    vsName: {
      type: String,
    },
    name: {
      type: String,
    },
    dataVvAs: {
      type: String,
    },
    vsValue: {
      type: String,
    },
    vValidate: {
      type: String,
    },
    label: {
      type: String
    }
  },
  data() {
    return {
      localValue: null,
    }
  },
  watch: {
    value (val) {
      this.localValue = val;
    },
    localValue (newValue) {
      this.$emit('input', newValue);
    }
  },
}
</script>

<style lang="scss">
@import '../../../assets/scss/custom/components/variables';

.radio-large {
  &.selected {
    .con-vs-radio {
      border: solid 2px $yellow;
      background-color: rgba(249, 219, 42, 0.13); // $yellow with 13% opacity
    }
  }

  .con-vs-radio {
    min-height: 131px;
    padding: 25px 40px;
    border: solid 2px $grey-light;
    border-radius: 5px;
    cursor: pointer;

    .label {
      font-size: 18px;
      padding-bottom: .5rem;
    }

    .slot-content {
      font-size: 13px;
      width: 256px;
    }

    .vs-radio {
      span.vs-radio--borde,
      span.vs-radio--circle {
        border-radius: 0;
      }

      span.vs-radio--borde {
        border: 1px solid $grey-light !important;
        background-color: $grey-lighter;
      }

      span.vs-radio--circle {
        border: 1px solid $yellow-light !important;
        background-color: $yellow;
      }
    }

    @media (max-width: 1199px) {
      padding: 23px 15px;
      min-height: 0;
    }
  }
}
</style>
